import React, { useState } from "react";
import  "./ProtectedAdmin.css";
import Admin from "./Admin";
import axios from "axios";


function ProtectedAdmin() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("http://localhost:5000/api/auth/login", {
        password,
      });
      localStorage.setItem("token", response.data.token); // Stocker le token
      setIsAuthenticated(true);
    } catch (error) {
      alert("Mot de passe incorrect !");
    }
  };

  if (isAuthenticated) {
    return <Admin />;
  }

  return (
    <div className="login-container">
      <h2>Accès Admin</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Se connecter</button>
      </form>
    </div>
  );
}

export default ProtectedAdmin;

